// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_b0-0";
export var orangeButton = "_b0-1";